module.exports = __webpack_public_path__ + "img/news7-2.eac95501.png";